import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { useCallback, useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useOutletContext } from "react-router-dom";
import { useEditableFlag } from "../../hooks/useEditableFlag";
import { SystemLoading, checkLoading } from "../../store/loadingStore";
import { MessageContext, handleSuccessMessage } from "../../store/messageStore";
import { queryRoleProductByRoleSeq, updateRoleProductList } from "../../utility/service/personal-service";
import { checkDpSuccess } from "../../utility/service/tool-service";
import { AcctContext } from "../../utility/useReduce/userNameReduce";

/** F2020107/F2020108 角色產品設定 **/
const RoleProductMaintain = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { itemObj } = useOutletContext();
  const [acctState] = useContext(AcctContext) || [];
  const [selected, setSelected] = useState([]);
  const [productList, setProductList] = useState([]);
  const [, dispatch] = useContext(MessageContext); //訊息視窗
  const [, loading] = useContext(SystemLoading);
  const isEditable = useEditableFlag("F202"); // 同權限管理

  const axios_queryRoleProductByRoleSeq = useCallback((roleSeq) => {
    checkLoading(loading);
    const companySeq = itemObj?.companySeq || acctState?.companySeq || "";
    queryRoleProductByRoleSeq({ roleSeq, companySeq })
      .then((res) => {
        if (checkDpSuccess(res)) {
          const list = res?.data?.RespBody?.productList || [];
          setProductList(list);
          const checked = list?.filter((p) => p.isCheck === "Y");
          setSelected(checked);
        }
      })
      .finally(() => checkLoading(loading, false));
  }, [loading, itemObj?.companySeq, acctState?.companySeq]);

  useEffect(() => {
    if (JSON.stringify(itemObj) !== "{}") {
      axios_queryRoleProductByRoleSeq(itemObj?.roleSeq);
    } else {
      navigate("/management/rolePermission");
    }
  }, [itemObj, axios_queryRoleProductByRoleSeq, navigate]);

  const axios_updateRoleProductList = (reqBody) => {
    checkLoading(loading);
    updateRoleProductList(reqBody)
      .then((res) => {
        if (checkDpSuccess(res)) {
          handleSuccessMessage(dispatch, t("button.update") + " " + t("message.success"));
          navigate("/management/rolePermission", { state: { roleSeq: itemObj?.roleSeq } });
        }
      })
      .finally(() => checkLoading(loading, false));
  };

  const handleSelectionChange = (e) => {
    const selectedItems = e.value.filter((rowData) => !rowData.disabled);
    setSelected(selectedItems);
  };

  const handleUpdateData = () => {
    let reqBody = {
      roleSeq: itemObj?.roleSeq,
      productList: selected?.map((p) => p?.offeringsId),
    };
    axios_updateRoleProductList(reqBody);
  };

  return (
    <>
      {/* 返回列表 */}
      <div className="align-items-start">
        <Button
          rounded
          text
          onClick={() => {
            navigate("/management/rolePermission");
          }}
        >
          <FontAwesomeIcon icon="fa-solid fa-arrow-left-long" />
          {t("button.return_to_list")}
        </Button>
      </div>
      <div className="p-card">
        <div className="p-card-body">
          <div className="grid">
            <div className="col-12">
              <label className="font-semibold mr-3">{t("role_symbol")}</label>
              <span>{itemObj?.symbol}</span>
            </div>
            <div className="col-12">
              <label className="font-semibold mr-3"> {t("role_name")}</label>
              <span>{itemObj?.name}</span>
            </div>
          </div>
          <hr />

          <DataTable
            dataKey="offeringsId"
            value={productList}
            selection={selected}
            onSelectionChange={handleSelectionChange}
            selectionMode="multiple"
            className="white-data-table hover-highlight"
            scrollable
            scrollHeight="70vh"
            emptyMessage={t("no_rec")}
            isDataSelectable={(rowData) => !rowData.disabled}
            rowClassName={(rowData) => {
              return `${rowData.disabled ? "p-disabled" : ""}`;
            }}
          >
            <Column selectionMode="multiple" headerStyle={{ width: "3rem" }}></Column>
            <Column field="productName" header={t("product_name")}></Column>
          </DataTable>
          <div className="grid mt-2">
            <div className="col-12 gap-2 flex-all-center">
              <Button disabled={!isEditable} label={t("button.update")} onClick={handleUpdateData} size="small" />
              <Button
                outlined
                size="small"
                label={t("button.cancel")}
                onClick={() => {
                  navigate("/management/rolePermission");
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RoleProductMaintain;
